<template>
  <v-snackbar location="top right" :color="color" :timeout="2000" v-model="show">
    <h3 v-html="message"></h3>
    <v-btn size="small" class="mt-2" text @click="show = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  data () {
    return {
      show: false,
      message: ''
    }
  },
  computed: {
    ...mapState([
      'snack',
      'color'
    ]),
  },
  methods: {
    ...mapMutations({
      setSnack: 'setSnack',
      setColor: 'setColor'
    }),
  },
  watch: {
    snack(snack){
      const msg = snack;
      if (msg !== '') {
        this.show = true
        this.message = snack
        this.setSnack('')
      }
    }
  },
}
</script>